import axios from "axios"
import { useStoreActions, useStoreState } from "easy-peasy"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { beep } from "./beep.js"
import ErrorPopup from "./ErrorPopup.js"
import { READ_USERS_URL } from "./Constants.js"
import UserFeed from "./UserFeed.js"

const User = () => {
	const [users, setUsers] = useState([])
	const [initialUserId, setInitialUserId] = useState(null)
	const [error, setError] = useState("")
	const navigate = useNavigate()
	// easy-peasy
	const Token = useStoreState((state) => state.Token)
	const AuthUser = useStoreState((state) => state.AuthUser)
	const setLoggedIn = useStoreActions((actions) => actions.setLoggedIn)
	const setHeaderCity = useStoreActions((actions) => actions.setHeaderCity)
	const setHeaderUser = useStoreActions((actions) => actions.setHeaderUser)

	useEffect(() => { if (error) beep() }, [error])

	// This is an api get call to the database users endpoint
	// All same city users are returned into the data object
	useEffect(() => {
		async function handleUsers() {
			try {
				// The login token is offered as authorization
				// for user access
				const request = {
					login_id: Token.login_id,
					client_id: Token.client_id,
					// expires: Token.expires,
				}
				const { data } = await axios.post(READ_USERS_URL, request)
				setUsers(data.users)
				setInitialUserId(data.initial_user_id)
			} catch (err) {
				setError(err.message)
				if (err.message === "Request failed with status code 401") {
					setError("Timeout")
				}
				// Code 422 indicates user tried to refresh page
				// React does not handle page refreshes so trigger a new login
				if (err.message === "Request failed with status code 422") {
					setError("422")
				}
				if (err.message === "Request failed with status code 500") {
					setError("500")
				}
			}
		}
		handleUsers()
	}, [])

	setTimeout(() => {
		// remove the message line
		if (error) {
			setHeaderCity("CR Cloud Technology")
			setHeaderUser("None")
			setLoggedIn(false)
			navigate("/login")
		}
	}, 3000)

	// Possible memory problem if number of users is extremely large
	// We may reduce the size by filtering by Department or something else

	// The User module is essential to all operations and therefore
	// always active. If the logged in user doesn't have user module
	// access, block adds and edits, but permit viewing of the user list.
	// Adds are blocked here. Edits are blocked in UserEdit.js
	// There is always at least one user.

	return (
		<main className="Main">
			{users[0] !== "" && !error && <UserFeed users={users} initialUserId={initialUserId} />}
			<ErrorPopup
				message={
					error === "Timeout" ? "Your session has timed out. Please login again." :
					error === "422" ? "Unable to use browser refresh button." :
					error === "500" ? "Unknown error — notify CR Cloud Technology." :
					error
				}
				onClose={() => setError("")}
			/>
		</main>
	)
}

export default User
